import { PROJECTS_REQUEST, PROJECTS_SUCCESS, PROJECTS_APPEND_SUCCESS, PROJECTS_FAIL, ALL_PROJECTS_SUCCESS } from "./types";
import { getRequest, postRequest } from "../../services/axios";
export const getProjects = (props) => async (dispatch) => {
	// do  not remove props 
	try {
		dispatch({ type: PROJECTS_REQUEST });
		if (props === "logout") {
			dispatch({
				type: PROJECTS_SUCCESS,
				payload: {
					projects: [],
				},
			});
		} else {
			const response = await getRequest("/project");
			if (response?.status === 200) {
				dispatch({
					type: ALL_PROJECTS_SUCCESS,
					payload: {
						allProjects: response.data.projects,
					},
				});
			return response;
			} else {
				const { data } = response?.response
				return data;
			}
		}

	} catch (error) {
		dispatch({
			type: PROJECTS_FAIL,
			payload: {
				error:
					error.response && error.response.data.message
						? error.response.data.message
						: error.message,
			},
		});
	}
};

export const getProjectsByPagination = (props, limit, page_no, search, append = false) => async(dispatch) => {
    try{
		// here in project request only isLoading will be true, and other state will be same as previous state
        dispatch({type: PROJECTS_REQUEST});
		if(props === "logout"){
            dispatch({
				type: PROJECTS_SUCCESS,
				payload: {
					projects: [],
				}
			});
		}else{
			const body = {limit, page_no, search};
			const response = await postRequest("/project/getUsersProjects", body);

			if(response?.data?.success){
				const projects = response.data.projects;
                dispatch({
					type: append ? PROJECTS_APPEND_SUCCESS : PROJECTS_SUCCESS,
					payload: {
						projects: projects,
						totalProjects: response.data.total
					}
				});
				return response;
			}
		}
	}catch(error){
       dispatch({
		  type: PROJECTS_FAIL,
		  payload: {
			  error: error.data.error
		  }
	   });
	}
}